import { Component, OnInit } from '@angular/core';
import { Globals } from 'src/app/global';

@Component({
  selector: 'app-property-pricerange',
  templateUrl: './property-pricerange.component.html',
  styleUrls: ['./property-pricerange.component.scss']
})
export class PropertyPricerangeComponent implements OnInit {

  constructor(public globals: Globals) { }

  section_modal: string = '';

  ngOnInit() {
    var modal=this.globals.getModalValue();
    if(undefined!=modal){
      this.section_modal=modal;
    }
  }

  setValue(value) {
    this.globals.setValue(value);
  }

}
